import "./productDetails.css";
import { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Divider,
  Skeleton,
  Stack,
  Typography,
} from "@mui/material";
import Layout from "../layout";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useMediaQuery } from "react-responsive";
import axios from "axios";
import CustomAxios from "../utils/CustomAxios";
import { updateCart } from "../redux/products";
import { updateCartSideBar } from "../redux/active_bar";
import Footer from "../components/footer";
import placeholder from "../assets/placeholder.jpg";
import ShareIcon from "@mui/icons-material/Share";
import {
  updateSnackBarMessage,
  updateSnackBarSeverity,
  updateSnackBarOpen,
} from "../redux/snackbar";
import MessageBar from "../modules/messageBar";
import { ArrowBack } from "@mui/icons-material";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import { Galleria } from "primereact/galleria";
import { classNames } from "primereact/utils";
import { TranslateText } from "../utils/googletranslator";
import { updateBPIntialState } from "../redux/bundleProduct";
import { Lock } from "@mui/icons-material";
import AttachMoney from "@mui/icons-material/AttachMoney";
import { updateReadyToBy } from "../redux/user_reducer";

const BundleProductDetails = () => {
  const cart = useSelector((state) => state.product?.cart);
  const Allproducts = useSelector((state) => state.product.Allproducts);
  const authtoken = localStorage.getItem("authtoken");
  const userId = useSelector((state) => state.user.id);
  const params = useParams();
  const dispatch = useDispatch();
  const [imageError, serImageError] = useState(true);
  const navigate = useNavigate();
  const [galleriaActiveImg, setGalleriaActiveImg] = useState(0);
  const member = useSelector((state) => state.user.member);
  const [bundle, setBundle] = useState(null);
  const [cartBundles, setCartBundles] = useState({});
  const [contentReady, setContentReady] = useState(false);
  const [bundleCartBusy, setBundleCartBusy] = useState(false);
  const [productContextPlans, setProductContextPlans] = useState([]);
  const [subscribedBundleIds, setSubscribedBundleIds] = useState([]);

  const isMobile = useMediaQuery({ maxWidth: 600 });
  const isLaptop = useMediaQuery({ query: "(max-width: 900px)" });

  const [touchStartEvent, setTouchStartEvent] = useState(null);
  const [touchMoveEvent, setTouchMoveEvent] = useState(null);

  const galleryImages = useMemo(() => {
    if (!bundle?.products?.length) return [];
    const fromProducts = bundle.products
      .map((p) => p.product?.cover_details?.original)
      .filter(Boolean);
    if (bundle.cover_details?.original) {
      return [bundle.cover_details.original, ...fromProducts];
    }
    return fromProducts;
  }, [bundle]);

  const handleGalleryTouchEnd = (e) => {
    e.preventDefault();
    const len = galleryImages.length;
    if (touchStartEvent?.clientX > touchMoveEvent?.clientX) {
      if (galleriaActiveImg < len - 1) setGalleriaActiveImg(galleriaActiveImg + 1);
    } else if (touchStartEvent?.clientX < touchMoveEvent?.clientX) {
      if (galleriaActiveImg > 0) setGalleriaActiveImg(galleriaActiveImg - 1);
    }
  };

  useEffect(() => {
    const uid = Number(userId);
    if (!authtoken || !uid) {
      setProductContextPlans([]);
      setSubscribedBundleIds([]);
      dispatch(updateReadyToBy({}));
      return;
    }
    CustomAxios.post("product_page_details/", { user_id: uid })
      .then((response) => {
        const context = response?.data || {};
        setProductContextPlans(
          Array.isArray(context.subscribedplan) ? context.subscribedplan : []
        );
        const bundleIds = Array.isArray(context.subscribed_bundle_ids)
          ? context.subscribed_bundle_ids.map((x) => Number(x))
          : [];
        setSubscribedBundleIds(bundleIds);
        const readyProductId = context.ready_to_buy_product_id;
        if (readyProductId && Array.isArray(Allproducts) && Allproducts.length) {
          const next = Allproducts.find((p) => p?.id === readyProductId);
          dispatch(updateReadyToBy(next || {}));
        } else {
          dispatch(updateReadyToBy({}));
        }
      })
      .catch(() => {
        setProductContextPlans([]);
        setSubscribedBundleIds([]);
        dispatch(updateReadyToBy({}));
      });
  }, [authtoken, userId, Allproducts, dispatch]);

  useEffect(() => {
    setBundle(null);
    setContentReady(false);
    setGalleriaActiveImg(0);
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    axios
      .get(`${process.env.REACT_APP_BACKEND_BASE_URL}bundles/${params.id}`)
      .then((response) => {
        const data = response.data;
        setBundle(data);
        dispatch(updateBPIntialState({ key: "bundle", value: data }));
        setContentReady(true);
      })
      .catch(() => {
        setBundle(null);
        setContentReady(false);
      });
  }, [params.id, dispatch]);

  const cartCheckLine = (p_obj) => {
    const pid = p_obj?.product?.id;
    const p_qty = p_obj?.product_quantity;
    const filt = cart.filter(
      (item) => item && item.product?.id == pid && item.quantity >= p_qty
    );
    return filt.length > 0 ? filt[0].quantity : false;
  };

  const CheckBundleStock = (b, condition) => {
    const b_products = b.products;
    let isOOS = [];
    let dummy_cart = [];
    if (cart?.length >= 1) dummy_cart = [...cart];
    else {
      try {
        dummy_cart = JSON.parse(localStorage.getItem("cart")) || [];
      } catch {
        dummy_cart = [];
      }
    }
    if (dummy_cart?.length >= 1) {
      isOOS = b_products?.map((e) => {
        let cart_qty =
          dummy_cart.filter((c_e) => c_e.product?.id === e?.product?.id)?.[0]
            ?.quantity || 0;
        if (condition) cart_qty += 1;
        else cart_qty -= 1;
        return cart_qty <= e.product?.inventry_details?.available_quantity
          ? { qty: cart_qty - 1, isOOS: false }
          : { qty: cart_qty - 1, isOOS: true };
      });
    }
    return isOOS.filter((e) => e.isOOS);
  };

  const FetchUserCart = async () => {
    const response = await CustomAxios.get(`usercart/${userId}`);
    dispatch(updateCart(response.data));
    localStorage.setItem("cart", JSON.stringify(response.data));
  };

  const handleCartBulk = async (cart_items) => {
    await Promise.all(
      cart_items?.map(async (p_item) => {
        const item = p_item.product;
        const quantity = p_item.quantity;
        if (!p_item?.id) {
          await CustomAxios.post(`cart/`, {
            products: item.id,
            quantity,
            user: userId,
            created_by: userId,
            price: item.selling_price,
            totalprice:
              quantity *
              (parseFloat(item.selling_price) +
                Math.round(item.selling_price * (item.tax / 100))),
            updated_by: userId,
          });
        } else {
          await CustomAxios.patch(`cart/${p_item.id}/`, {
            quantity: p_item.quantity,
            totalprice:
              p_item.quantity *
              (parseFloat(p_item.price) +
                Math.round(p_item?.price * (p_item.product?.tax / 100))),
          });
        }
      })
    );
  };

  const addBundleCart = async (b, qty, e) => {
    e.stopPropagation();
    const products = b.products;
    const bundleCheck = CheckBundleStock(b, true);
    if (bundleCheck?.length !== 0) {
      dispatch(
        updateSnackBarMessage(
          `Just ${bundleCheck[0].qty} of ${b.name} bundle(s) left! We'll have more in stock for you very soon.`
        )
      );
      dispatch(updateSnackBarSeverity("error"));
      dispatch(updateSnackBarOpen(true));
      return;
    }
    setBundleCartBusy(true);
    const cart_items = await Promise.all(
      products?.map(async (p_obj) => {
        const item = p_obj.product;
        const itemCCheck = cartCheckLine(p_obj);
        if (item && typeof itemCCheck === "boolean") {
          return {
            product: item,
            quantity: qty,
            price:
              authtoken && member == "member"
                ? item.selling_price
                : item.price,
            originalPrice: item.price,
          };
        }
        if (item && typeof itemCCheck === "number") {
          let dummy_cart =
            cart?.length >= 1
              ? [...cart]
              : JSON.parse(localStorage.getItem("cart")) || [];
          let index;
          const modified_cart = dummy_cart?.map((row, e_id) => {
            const obj = { ...row };
            const p_id = obj.products || obj.product?.id;
            if (p_id === p_obj?.product_id) {
              index = e_id;
              obj.quantity = obj.quantity + 1;
            }
            return obj;
          });
          return modified_cart[index];
        }
        return null;
      })
    );
    const dummyCB = { ...cartBundles };
    dummyCB[b.id] = { qty };
    setCartBundles(dummyCB);
    let merged = cart_items?.filter(Boolean) || [];
    const updated_cart = new Map();
    const old_cart_items = cart
      ? [...cart]
      : JSON.parse(localStorage.getItem("cart")) || [];
    old_cart_items.forEach((item) =>
      updated_cart.set(item?.product?.id, item)
    );
    merged.forEach((item) => {
      if (updated_cart.has(item?.product?.id)) {
        const ex = { ...updated_cart.get(item?.product?.id) };
        ex.quantity = item.quantity;
        updated_cart.set(item?.product?.id, ex);
      } else {
        updated_cart.set(item?.product?.id, item);
      }
    });
    merged = Array.from(updated_cart.values());
    dispatch(updateCart(merged));
    localStorage.setItem("cart", JSON.stringify(merged));
    if (authtoken) {
      await handleCartBulk(merged);
      await FetchUserCart();
    }
    setBundleCartBusy(false);
    dispatch(updateSnackBarMessage(`Successfully Added ${b?.name || ""} to Cart!`));
    dispatch(updateSnackBarSeverity("success"));
    dispatch(updateSnackBarOpen(true));
    dispatch(updateCartSideBar(true));
  };

  const handleCopyurl = (bid) => {
    const url = process.env.REACT_APP_URL + `bundle_details/${bid}`;
    navigator.clipboard
      .writeText(url)
      .then(() => {
        dispatch(updateSnackBarMessage("URL copied to clipboard!"));
        dispatch(updateSnackBarSeverity("success"));
      })
      .catch((error) => {
        dispatch(updateSnackBarMessage(String(error)));
        dispatch(updateSnackBarSeverity("error"));
      });
    dispatch(updateSnackBarOpen(true));
  };

  const hasVideoAccess = Boolean(
    authtoken &&
      bundle &&
      subscribedBundleIds.includes(Number(bundle.id))
  );

  const firstRelatedProduct = bundle?.products?.[0]?.product || null;

  return (
    <Box sx={{ display: "flex", flexDirection: "column" }}>
      <Layout />
      <MessageBar />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          padding: { xs: "10px 24px", sm: "10px 24px", md: "32px 120px" },
          gap: "24px",
          marginTop: "118px",
        }}
      >
        <Box
          sx={{ display: "flex", gap: "10px", cursor: "pointer" }}
          onClick={() => navigate("/products")}
        >
          <ArrowBack /> <TranslateText>Our product</TranslateText>
        </Box>
        <Box
          sx={{
            display: "flex",
            gap: "30px",
            alignItems: "center",
            flexDirection: { xs: "column", sm: "column", md: "row" },
            width: "100%",
          }}
        >
          {!bundle?.products || bundle?.products?.length === 0 ? (
            <Stack
              direction={!isMobile && !isLaptop ? "row" : "column-reverse"}
              sx={{
                width: { xs: "inherit", md: "unset" },
                height: "460px",
                justifyContent: "flex-start",
                alignItems: "center",
              }}
            >
              <Skeleton
                component={Box}
                sx={{
                  width: { xs: "50%", md: "96px" },
                  height: { xs: "10%", md: "100%" },
                  borderBottom: "1px solid #f8f9ff",
                  p: "8px",
                  transform: "none",
                }}
              />
              <Skeleton
                sx={{
                  width: { xs: "inherit", md: "496px" },
                  height: "100%",
                  p: "24px",
                  border: "1px solid #f8f9ff",
                  transform: "none",
                }}
              />
            </Stack>
          ) : galleryImages.length > 0 ? (
            <Galleria
              activeIndex={galleriaActiveImg}
              onItemChange={(e) => setGalleriaActiveImg(e.index)}
              style={{ width: { xs: "inherit", md: "unset" } }}
              pt={{
                previousThumbnailButton: ({ state }) => ({
                  className:
                    galleryImages.length < 4 ? classNames("p-disabled") : "",
                }),
              }}
              value={galleryImages}
              thumbnailsPosition={!isMobile && !isLaptop ? "left" : "bottom"}
              thumbnail={(image) => (
                <Box
                  component="img"
                  src={image || placeholder}
                  onError={() => serImageError(false)}
                  sx={{
                    maxWidth: "96px",
                    maxHeight: "86px",
                    height: "100%",
                    width: "100%",
                    borderBottom: "1px solid #f8f9ff",
                    p: "8px",
                  }}
                />
              )}
              item={(image) => (
                <Box
                  component="img"
                  onTouchStart={(e) => setTouchStartEvent(e.touches[0])}
                  onTouchMove={(e) => setTouchMoveEvent(e.touches[0])}
                  onTouchEnd={(e) => handleGalleryTouchEnd(e)}
                  src={image || placeholder}
                  sx={{
                    width: { xs: "350px", md: "100%" },
                    height: { xs: "350px", md: "100%" },
                    maxWidth: "496px",
                    maxHeight: "460px",
                    p: "24px",
                    border: "1px solid #f8f9ff",
                  }}
                />
              )}
              numVisible={4}
              showThumbnails={
                isMobile || isLaptop || galleryImages.length < 4 ? false : true
              }
              showIndicators={isMobile || isLaptop ? true : false}
            />
          ) : (
            <Box
              component="img"
              src={placeholder}
              sx={{ maxWidth: "496px", width: "100%", borderRadius: 1 }}
            />
          )}

          {contentReady && bundle ? (
            <Box
              sx={{
                display: "flex",
                gap: "11px",
                flexDirection: "column",
                maxWidth: { xs: "100%", sm: "100%", md: "562px" },
              }}
            >
              {!hasVideoAccess && (
                <TranslateText
                  sx={{
                    fontSize: "14px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    height: "24px",
                    bgcolor: "#FACC15",
                    padding: "0px 8px",
                    borderRadius: "6px",
                    textAlign: "center",
                    alignSelf: "start",
                  }}
                >
                  Combo
                </TranslateText>
              )}
              <TranslateText
                sx={{
                  fontSize: { xs: "24px", sm: "24px", md: "36px" },
                  fontWeight: "700",
                  lineHeight: "43.2px",
                }}
              >
                {bundle.name}
              </TranslateText>
              {bundle?.products?.map((p_obj) => (
                <TranslateText key={p_obj?.id || p_obj?.product?.id}>
                  {String(p_obj.product_quantity)}× {p_obj?.product?.name}
                </TranslateText>
              ))}
              {!hasVideoAccess && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: { xs: "4px", md: "16px" },
                  }}
                >
                  <Box sx={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                    <Typography
                      sx={{
                        fontSize: "32px",
                        fontWeight: "700",
                        lineHeight: "38.4px",
                        color: "primary.light",
                      }}
                    >
                      <sup>
                        <AttachMoney
                          sx={{
                            fontSize: "16px",
                            fontWeight: 700,
                            color: "primary.light",
                          }}
                        />
                      </sup>
                      {bundle?.price}
                    </Typography>
                  </Box>
                </Box>
              )}
              {!hasVideoAccess && (
                <TranslateText
                  sx={{
                    fontSize: "16px",
                    fontWeight: "400",
                    lineHeight: "19.2px",
                    color: "grey.600",
                  }}
                >
                  Inclusive of GST
                </TranslateText>
              )}
              {hasVideoAccess ? (
                <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  {bundle?.products?.map((p_obj) => {
                    const productId = p_obj?.product?.id;
                    const productName = p_obj?.product?.name;
                    if (!productId) return null;
                    return (
                      <Button
                        key={`product-link-${productId}`}
                        variant="contained"
                        sx={{
                          width: "100%",
                          bgcolor: "black",
                          height: "36px",
                          padding: "8px 12px",
                          textTransform: "none",
                        }}
                        onClick={() => navigate(`/product_details/${productId}`)}
                      >
                        <TranslateText sx={{ fontSize: "14px" }}>
                          View {productName || "Product"}
                        </TranslateText>
                      </Button>
                    );
                  })}
                </Box>
              ) : (
                <Button
                  variant="contained"
                  disabled
                  sx={{
                    width: "100%",
                    bgcolor: "#CBD5E1",
                    color: "#475569",
                    height: "36px",
                    padding: "8px 12px",
                    textTransform: "none",
                    boxShadow: "none",
                    "&.Mui-disabled": {
                      bgcolor: "#CBD5E1",
                      color: "#475569",
                    },
                  }}
                >
                  <Lock sx={{ marginRight: "10px" }} />
                  <TranslateText sx={{ fontSize: "14px" }}>Not eligible</TranslateText>
                </Button>
              )}
            </Box>
          ) : (
            <Box
              sx={{
                display: "flex",
                gap: "11px",
                flexDirection: "column",
                maxWidth: { xs: "100%", sm: "100%", md: "562px" },
                width: "100%",
              }}
            >
              <Skeleton variant="rounded" width={70} height={24} />
              <Skeleton variant="rectangle" width={isMobile ? "100%" : 570} height={85} />
              <Skeleton variant="rectangle" width={isMobile ? "100%" : 570} height={24} />
              <Skeleton variant="rectangle" width={isMobile ? "100%" : 570} height={36} />
            </Box>
          )}
        </Box>
      </Box>

      <Footer />
    </Box>
  );
};

export default BundleProductDetails;
